module.exports = __webpack_public_path__ + "static/media/android.cfd2050e.png";